import { Component, Input } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { Router } from '@angular/router';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss'
})
export class ProductComponent {
  @Input() product: any;
  imageUrl = environment.ImageBaseUrl ;
  constructor(
    private router: Router,private api:ApiServiceService
  ){

  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  ViewProduct(productId: any){
    this.router.navigate(["product-details", productId]);
    this.api.productClick(this.product._id).subscribe();
  }
  
  getRatingArray(rating: number): boolean[] {
    const stars = Array(5).fill(false);
    for (let i = 0; i < Math.round(rating); i++) {
      stars[i] = true;
    }
    return stars;
  }

//   scrollTop(){
//     window.scrollTo({ top: 0});
  
// }
}
